import PropTypes from 'prop-types';
import styles from './FJLoadingModal.module.less';
import FJLoading from '../../../common/components/FJLoading/FJLoading';

const FJLoadingModal = ({ message }) => {
    return (
        <div className={styles.box}>
            <div className={styles.loading_box}>
                <FJLoading />
            </div>
            <div className={styles.message}>{message}</div>
        </div>
    );
};

FJLoadingModal.propTypes = {
    message: PropTypes.string,
};

export default FJLoadingModal;
